import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Router, UrlSerializer } from '@angular/router';

@Injectable()
export class EndpointTestingService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private serializer: UrlSerializer
  ) {}

  testEndpoint(contentType: string, body: any): Observable<any> {
    return this.http.post(environment.controlBaseUrl + '/endPointTest', body);
  }

  toURLString(url: string, params: Array<any>) {
    let queryParams = {};

    params.forEach((param) => {
      let key = Object.keys(param)[0];
      if (key.trim() != '') {
        queryParams[key] = param[key];
      }
    });

    const tree = this.router.createUrlTree([], { queryParams });
    let serializedTree: string = this.serializer.serialize(tree);
    let queryString = '';
    if (serializedTree.indexOf('?') != -1) {
      queryString = serializedTree.slice(serializedTree.indexOf('?') + 1, serializedTree.length);
    }
    queryString = queryString.replace('?', '');

    if (url.indexOf('?') === -1 && queryString.length != 0) {
      url = url + '?';
    }
    return url + queryString;
  }
}
